export default class ExceptionUtils {
    public static getErrorMessage(error: any, defaultMessage?: string): string {
        let response = error.response;
        let message;
        if (response) {
            let responseData = response["data"];
            if (responseData) {
                message = responseData["message"]
            } else {
                message = defaultMessage ?? "Sorry, an error occurred";
            }
        } else {
            message = defaultMessage ?? "Sorry, an error occurred";
        }
        return message;
    }
}